import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceUtil } from '../utilities/service.util';
import { ChangePassword } from '../models/change-password.model';
import { SecurityQuestion } from '../models/security-question.model';
import { SecurityQuestionAnswer } from '../models/security-question-answer.model';
import { UserProfile } from '../models/user-profile.model';

@Injectable()
export class ProfileService {
  private _controllerName: string = 'profile';

  constructor(private _serviceUtil: ServiceUtil, private _http: HttpClient) { }

  async changePassword(changePassword: ChangePassword): Promise<any> {
    return this._serviceUtil.doPostRequestAsync(this._controllerName, 'ChangePassword', changePassword);
  }

  async getUserProfileData(): Promise<any> {
    return this._serviceUtil.doGetRequestAsync<UserProfile>(this._controllerName, 'GetUserProfileData');
  }

  async getSecurityQuestions(): Promise<SecurityQuestion[]> {
    return this._serviceUtil.doGetRequestAsync<SecurityQuestion[]>(this._controllerName, 'GetSecurityQuestions');
  }

  async getExistingUserSecurityQuestions(): Promise<SecurityQuestionAnswer[]> {
    return this._serviceUtil.doGetRequestAsync<SecurityQuestionAnswer[]>(this._controllerName, 'GetExistingUserSecurityQuestions');
  }

  async getPasswordRecoveryAnswersCount(): Promise<number> {
    return this._serviceUtil.doGetRequestAsync<number>(this._controllerName, 'GetPasswordRecoveryAnswersCount');
  }

  async saveSecurityQuestions(answers: SecurityQuestionAnswer[]): Promise<any> {
    return this._serviceUtil.doPostRequestAsync('PasswordRecovery', 'Save', answers);
  }

  async enableAuthenticator(): Promise<any> {
    return this._serviceUtil.doGetRequestAsync<any>(this._controllerName, 'EnableAuthenticator');
  }

  async verifyAuthenticator(code: string): Promise<any> {
    return this._serviceUtil.doPostRequestAsync(this._controllerName, 'EnableAuthenticator', code);
  }

  async getEnableAuthenticatorDetails(): Promise<any> {
    return this._serviceUtil.doGetRequestAsync<any>(this._controllerName, 'EnableAuthenticatorDetails');
  }

  async resetAuthenticator(): Promise<any> {
    return this._serviceUtil.doPostRequestAsync(this._controllerName, 'ResetAuthenticator', null);
  }
}
